import { INITIAL_DATA_LOADED } from '../actions/CompoundFetchActions';
import FeatureSwitchService from '../services/FeatureSwitchService';

const initialState = {
	values: {}
};

export default class FeatureSwitchesReducer {
	static reduce(state = initialState, action) {
		switch (action.type) {
			case INITIAL_DATA_LOADED:
				return {
					...state,
					values: FeatureSwitchService.map(action.featureSwitches)
				};
			default:
				return state;
		}
	}
}


// WEBPACK FOOTER //
// ./reducers/FeatureSwitchReducer.js